import { render, staticRenderFns } from "./StatisticsUsers.vue?vue&type=template&id=f9a66c28&"
import script from "./StatisticsUsers.vue?vue&type=script&lang=js&"
export * from "./StatisticsUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports